<my-table
  #table
  key="RunnerListComponent"
  [defaultColumns]="columns"
  i18n-paginatorText
  paginatorText="runners per page"
  [dataLoader]="dataLoader"
  columnConfig="false"
>
  <ng-template #totalTitle let-totalRecords>
    <ng-container i18n>{ totalRecords, plural, =0 {No runner} =1 {1 runner} other {{{ totalRecords | myNumberFormatter }} runners}}</ng-container>
  </ng-template>

  <ng-template #tableCells let-runner>
    <td>{{ runner.name }}</td>

    <td class="max-width-300px ellipsis">{{ runner.description }}</td>

    <td>{{ runner.ip }}</td>

    <td>{{ runner.version }}</td>

    <td>{{ runner.lastContact | ptDate: 'short' }}</td>

    <td>{{ runner.createdAt | ptDate: 'short' }}</td>
  </ng-template>

  <ng-template #actionCell let-runner>
    <my-action-dropdown
      placement="bottom-right top-right left auto" container="body"
      i18n-label label="Actions" [actions]="actions" [entry]="runner"
    ></my-action-dropdown>
  </ng-template>

  <ng-template #noResults>
    <ng-container i18n>No remote runners found.</ng-container>
  </ng-template>
</my-table>
